import { render } from "./selectSchool.vue?vue&type=template&id=c1650f58&scoped=true"
const script = {}

import "./selectSchool.vue?vue&type=style&index=0&id=c1650f58&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c1650f58"]])

export default __exports__